(function () {

  'use strict';

  /**
   * @author Ronald Nicholls
   * @description wraps directive for currency filter
   * @ngdoc directive
   * @name uteCurrency
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

  /**
   * @class ute-ui.extras.uteCurrency
   */
    .directive('uteCurrency', ["$http", "$rootScope", "$filter", "$sce", "$translate", "uteLocale", function ($http, $rootScope, $filter, $sce, $translate, uteLocale) {

      return {
        scope: {
          fontSize: '@',
          price: '@',
          frequency: '@',
          tax: '=',
          showCents: '@'
        },
        transclude: false,
        replace: true,
        template: '<span ng-style="{fontSize: fontSize};"><ins ng-bind-html="currencyValue"></ins></span>',
        restrict: 'EA',
        link: function ($scope) {

          /**
           * @name fontSize
           * @description check if fontSize attribute exists or is set
           * @type {string}
           */
          $scope.fontSize = $scope.fontSize || '5rem';

          /**
           * @name buildCurrency
           * @description Builds currency with proper DOM structure
           * @param value - currency amount
           */
          var buildCurrency = function (value) {

            var currencySymbol = '<sup>$</sup>',
              toEnglish,
              toFrench,
              taxText = '',
              freq = '';

            toEnglish = function () {
              $scope.centsClass = $scope.showCents === 'false' ? 'hidden' : '';
              var priceArray = value.toString().replace('$', '').split('.');
              $scope.currencyValue = $sce.trustAsHtml(currencySymbol + priceArray[0] + '<sup class="' + $scope.centsClass + '">.' + priceArray[1] + '</sup>' + taxText + freq);
            };

            toFrench = function () {
              var priceArray = value.toString().replace('$', '').split(',');
              $scope.currencyValue = $sce.trustAsHtml(priceArray[0] + '<sup class="' + $scope.centsClass + '">,' + priceArray[1] + '</sup>' + currencySymbol + taxText + freq);
            };

            $scope.getCurrencyValue = function () {

              if ($scope.tax) {
                var tax = parseFloat($scope.tax);
                if (tax && _.isNumber(tax)) {
                  taxText = '<span class="plux-tax-text">+' + tax.toFixed(2).toString() + '</span>';
                } else {
                  var plusTax = uteLocale.language === 'en' ? '+ taxes' : '+ taxes';
                  taxText = '<span class="plux-tax-text">' + plusTax + '</span>';
                }
              }

              if (uteLocale.language === 'en') {
                toEnglish();
              } else if (uteLocale.language === 'fr') {
                toFrench();
              } else {
                toEnglish();
              }
            };

            if (angular.isDefined($scope.frequency)) {
              $translate.use(uteLocale.language);
              $translate($scope.frequency)
                .then(function (result) {
                  freq = '<sub>' + result + '</sub>';
                  $scope.getCurrencyValue();
                });
            } else {
              $scope.getCurrencyValue();
            }

          };


          /**
           * @description watch for locale change & initialization. buildCurrency when everything is ok
           */
          $scope.$watch(function () {
            var priceNumber = Number($scope.price.replace('$', ''));
            $scope.price = !isNaN(priceNumber) ? $scope.price : '$0.00';
            $scope.price = $scope.price.replace('$', '').toString();
            return $filter('currency')($scope.price, '$');
          }, function (value) {
            buildCurrency(value);
          });

        }

      };
    }]);

})();
